import React from 'react';

import { SUBSCRIPTION_LABEL_STATES } from '../constants';
import { ISubscriptionRedemption } from '../types';

import AdditionalStatusInfo from './subComponents/AdditionalStatusInfo';
import BillingPeriod from './subComponents/BillingPeriod';
import CancelSubscriptionBlock from './subComponents/CancelSubscriptionBlock';
import { IncludedInYourPlanRow } from './subComponents/IncludedInYourPlanRow';
import PeriodRow from './subComponents/PeriodRow';
import PriceRow from './subComponents/PriceRow';
import SubscriptionCardHeader from './subComponents/SubscriptionCardHeader';
import SubscriptionStatusLabel from './subComponents/SubscriptionLabel';
import SubscriptionCardWrapper from './SubscriptionCardWrapper';

import * as S from './styled';

const SubscriptionRedemption = ({
    tabIcon,
    heading,
    subscriptionPeriod,
    price,
    onCancelSubscription,
    isTrial,
    isUpgrade,
    isMainSubscription,
    productCode,
    captions,
    isOneTimeProduct,
    expirationDate,
}: ISubscriptionRedemption) => {
    return (
        <SubscriptionCardWrapper>
            <SubscriptionCardHeader
                isMainSubscription={isMainSubscription}
                productCode={productCode}
                Icon={tabIcon}
                heading={heading}
            />
            <S.GeneralInfo>
                <SubscriptionStatusLabel state={SUBSCRIPTION_LABEL_STATES.PAYMENT_ISSUE} />
                <PeriodRow period={subscriptionPeriod} isTrial={isTrial} />
                <PriceRow price={price} />
                <BillingPeriod period={subscriptionPeriod} />
                {isUpgrade && <IncludedInYourPlanRow isCardRow />}
                <S.Line $mt={16} />
            </S.GeneralInfo>
            {captions?.title && <AdditionalStatusInfo captions={captions} />}
            <CancelSubscriptionBlock
                isOneTimeProduct={isOneTimeProduct}
                date={expirationDate}
                onCancel={onCancelSubscription}
            />
        </SubscriptionCardWrapper>
    );
};

export default SubscriptionRedemption;
